import React, { useCallback, useRef } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { WMDefaultsLayout } from "../Layouts";

function WMDefaultTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    
    const onFormLoad = useCallback(() => {
        props.wmDefaultsFormLookupsLoad(formRefs);
    });

    const handleFieldChange = useCallback((name, value, e) => {
    }, []);



    return (
        <div className="FormMt">
            <FormField
                currrentUser={currentUser}
                layoutId='4A5F3225-C5FE-4A27-9BC8-F156CB4848AF'
                layoutName='CarrierWMDefaultsTab'
                defaultFormSchema={WMDefaultsLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={onFormLoad}
            />
        </div>


    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(WMDefaultTab);
